import { validations } from "../../../../../config/validations/validations";

export const rules: any = {
  name: () => [
    validations.required.text(),
    validations.min.text(3),
    validations.max.text(50),
  ],
};
